module.exports = require('./lib/static/prefixAll')



//////////////////
// WEBPACK FOOTER
// /workspace/Release/~/inline-style-prefixer/static.js
// module id = 315
// module chunks = 6